export default function initMustBeTrueValidator() {

    $.validator.unobtrusive.adapters.add("mustbetrue", [],
        function (options) {
            options.messages['mustbetrue'] = options.message;
            options.rules['mustbetrue'] = {};
        }
    );



    $.validator.addMethod("mustbetrue", function (value) {
        return value == 'true';
    })


}



